import { useTranslation } from '@frontend/i18n';
import { BulkEmailPrefixes } from '@frontend/tracking-prefixes';
import { useContentComposer } from '../../content-composer/content-composer-provider';
import { ToolboxButton } from '../../content-composer/toolbox-atoms/toolbox-button';
import { ImageSection } from './image-section';

export const ImageTool = () => {
  const { t } = useTranslation('content-composer');
  const { insertSection } = useContentComposer();

  return (
    <ToolboxButton
      icon='image'
      title={t('Image')}
      subtitle={t('Insert an image.')}
      onClick={() => insertSection(<ImageSection />)}
      trackingId={`${BulkEmailPrefixes.Composer}-image-tool-btn`}
    >
      <ImageSection />
    </ToolboxButton>
  );
};
